$(document).ready(function () {
  // Define your birthday
  const birthdayDate = new Date("2019-06-06"); // Change this to your actual birthday date

  // Get the current date
  const currentDate = new Date();

  // Calculate the number of years since your birthday
  const yearsSinceBirthday =
    currentDate.getFullYear() - birthdayDate.getFullYear();

  // Check if it's your birthday and add the "birthday" class to H1 elements
  if (
    currentDate.getDate() === birthdayDate.getDate() &&
    currentDate.getMonth() === birthdayDate.getMonth()
  ) {
    $("h1").addClass("birthday");

    // Add a <span> element inside h1.birthday to display the years
    $("h1.birthday").append(
      `<span class="birthday-age">The Branding Club bestaat vandaag ${yearsSinceBirthday} jaar!!</span>`
    );
  }
  $("h1.birthday").click(function () {
    confetti(); // Call your confetti function
  });
});
